<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            @click="showFilter = !showFilter"
          >
            <i class="fa fa-filter"></i> Filter
          </button>
          <b-button variant="primary mr-1" @click="exportxlsPrepaidAlloc()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend>
                        <label>Source Project&nbsp;</label>
                        </b-input-group-prepend>
                        <b-form-select
                        v-model="tblData.pjxkey"
                        :plain="true"
                        :options="sourceproject"
                        ></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.customer"
                  placeholder="Customer"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">Debitur No. (CIF)</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.CustCode"
                  placeholder="Debitur No"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">No. Agreement</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.agreement"
                  placeholder="No Agreement"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">No. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.nomor"
                  placeholder="No Kontrak"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Next Installment</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.next_installment_date_1" type="date"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">until</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.next_installment_date_2" type="date"></b-form-input>
            <b-input-group-prepend> </b-input-group-prepend>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Next Installment Due</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.next_installment_due_date_1" type="date"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">until</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.next_installment_due_date_2" type="date"></b-form-input>
            <b-input-group-prepend> </b-input-group-prepend>
          </b-input-group>
           <div class="text-right">
               <b-button
                    variant="success"
                    @click="refresh()"
                    class="ml-3"
                >
                    <i class="fa fa-refresh"></i> Apply Filter
                </b-button>
                <b-button
                    variant="secondary"
                    class="ml-2"
                    @click="clearFilter()"
                    >Clear Filter</b-button
                >
           </div>
        </b-col>
      </b-row>
      <b-card no-body class="mb-0 mt-2">
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          style="font-size: smaller"
          :items="data"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
          :busy="isBusy"
          show-empty
        >
          <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
          <template v-slot:cell(tgl_kontrak)="data">{{
            data.item.tgl_kontrak | moment("DD/MM/YYYY")
          }}</template>
           <template v-slot:cell(next_installment_date)="data">{{
            data.item.next_installment_date | moment("DD/MM/YYYY")
          }}</template>
            <template v-slot:cell(next_installment_due_date)="data">{{
            data.item.next_installment_due_date | moment("DD/MM/YYYY")
          }}</template>
          
          <template v-slot:cell(pbb_os)="data">{{
            data.item.pbb_os | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(installment_amount)="data">{{
            data.item.installment_amount | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(tenor)="data">{{
            data.item.tenor | numFormat
          }}</template>
          <template v-slot:cell(startdate)="data">{{
            data.item.startdate | moment("DD/MM/YYYY")
          }}</template>
          <template v-slot:cell(duedate)="data">{{
            data.item.duedate | moment("DD/MM/YYYY")
          }}</template>
        <template v-slot:cell(action)="data">
              <b-button variant="warning" size="sm" @click="$router.push({name:'loan.prepaidallocationform',params:{isfrominstallmentduewithprepaid:true,dtset:data.item}});saveFilter();"><i class="fa fa-play"></i>&nbsp; Allocation</b-button>
        </template>
          
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
        </b-table>
      </b-card>

      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width: 80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import myNumber from "../../components/my-number";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import pinjaman from "../../apis/pinjamankredit";
import project from "../../apis/project";
import crud from "../../apis/crud";

toastr.init();
export default {
  components: { myNumber, Loading },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      model: {},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        next_installment_date_1:'',
        // moment().startOf('month').format('YYYY-MM-DD'),
        next_installment_date_2:moment().format('YYYY-MM-DD'),
        next_installment_due_date_1:'',
        next_installment_due_date_2:'',
        sortBy: "no_kontrak",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        sourceproject: this.$store.state.user.compcode || "",
        contract_status: "",
        wo_status: 0,
      },
      collectors: [{ value: "", text: "--- ALL ---" }],
      modelkredit: [
        { value: "", text: "--- ALL ---" },
        { value: "PAB", text: "Angsuran Bulanan" },
        { value: "PRK", text: "Rekening Koran" },
      ],
      kolStatus: [
        { value: "", text: "--- ALL ---" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
      ],
      statuses: [
        { value: "", text: "--- ALL ---" },
        // { value: "EXP", text: "Expired"},
        // { value: "CAN", text: "Cancel"},
        // { value: "INV", text: "Inventory"},
        { value: "LIV", text: "Live"},
        { value: "ICP", text: "Incomplete Payment"},
        { value: "RRD", text: "Ready Release Document"},
        // { value: "PRP", text: "Prospect"},
      ],
      sourceproject: [{ value: "", text: "--- ALL ---" }],
      wostatus: dropdown.woStatus,
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thStyle: "width:140px",
          sortable: true,
        },
        {
          key: "no_agreement",
          label: "No. Agreement",
          thStyle: "width:140px",
          sortable: true,
        },
         {
          key: "CustCode",
          label: "CIF",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Debitur Name",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true,
        },
        
        {
          key: "startdate",
          label: "Go Live Date",
          thStyle: "width:100px",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "duedate",
          label: "Maturity Date",
          thStyle: "width:100px",
          tdClass: "text-right",
          sortable: true,
        },
        
        {
          key: "matauang",
          label: "CCY",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tenor",
          label: "Tenor (Bulan)",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "pbb_os",
          label: "Prepaid Balance",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "installment_amount",
          label: "Installment Amount",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "next_installment_date",
          label: "Next Installment Date",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "next_installment_due_date",
          label: "Next Installment Due Date",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
       
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  async created() {
    // this.isBusy = true;
    // this.data();
    const collSet = {
      tablename: "vwcollector",
      // page: 1,
      // limit: 20,
      // total: 0,
    };
    const collector = await crud.list(collSet);
    collector.map((dt) => {
      this.collectors.push({ value: dt.collector_id, text: dt.crewname });
    });

    const projectDt = await project.listbyuser();
    this.sourceproject = projectDt.reduce((arr = [{ value: "", text: "--- ALL ---" }], item, index) => {
      arr.push({
        value: item.pjxkey,
        text: item.pjxname,
      });
      return arr;
    }, [{ value: "", text: "--- ALL ---" }]);

    this.tblData.pjxkey = this.tblData.pjxkey || (this.sourceproject.length>0?this.sourceproject[0].value:''); 
    if(this.$route.params&&this.$route.params.contract_status){
      this.tblData.contract_status = this.$route.params.contract_status;
      this.refresh();
    }
  },
  methods: {
    saveFilter() {
      const keys = ['customer','nasabahkey', 'collectability','nomor', 'agreement', 'collector_id', 'model_pinjaman', 'tgl1', 'tgl2','dod1', 'dod2','wo_status','contract_status','pjxkey', 'CustCode', 'pjxname', 'next_installment_date_1' , 'next_installment_date_2','next_installment_due_date_1','next_installment_due_date_2'];
      let filtered = false;
      const insallduewithprepaid={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              insallduewithprepaid[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          insallduewithprepaid.page=this.tblData.page;
          insallduewithprepaid.limit=this.tblData.limit;
          insallduewithprepaid.sortBy=this.tblData.sortBy;
          insallduewithprepaid.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.insallduewithprepaid=insallduewithprepaid;
          this.$store.commit("filter", filter);
      }
    }, 
    async exportDtl() {
      if (this.model.pinjamankey) {
        try {
          await pinjaman.exportDtlxls(this.model.pinjamankey);
        } catch (error) {
          this.isBusy = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      } else {
        toastr.warn("Please select a row that want to export detail");
      }
    },

    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      if (record.isReturn === 1) {
        this.disabledRetur = true;
      } else {
        this.disabledRetur = false;
      }

      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    data: async function (ctx) {
      try {
          const filter = this.$store.state.filter;
          let filtered=false;
          for (var key in filter.insallduewithprepaid) {
              this.tblData[key] = filter.insallduewithprepaid[key];
              filtered=true;
          }
          if (filtered === true) {
            this.tblData.tgl1=filter.insallduewithprepaid.tgl1 || '';
            this.tblData.tgl2=filter.insallduewithprepaid.tgl2 || '';
            this.showFilter=filtered;
            delete filter.insallduewithprepaid;
            this.$store.commit("filter", filter);
          }
        const list = await pinjaman.installmentduewithprepaid(this.tblData);
        this.isBusy = false;
        return list;
      } catch (error) {
        console.log("error : ", error);
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData.customer = "";
      this.tblData.nomor = "";
      this.tblData.agreement = "";
      this.tblData.pjxkey = "";
      this.tblData.CustCode = "";
      this.tblData.pjxname = "";
      this.tblData.next_installment_date_1 = "";
      this.tblData.next_installment_date_2 = "";
      this.tblData.next_installment_due_date_1 = "";
      this.tblData.next_installment_due_date_2 = "";
      this.refresh();
    },
    async exportxlsPrepaidAlloc() {
      try {
        await pinjaman.exportxlsPrepaidAlloc(this.tblData);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push("home");
    },
  },
};
</script>